import { useLocation, Navigate } from 'react-router-dom'
import { useAuthStore } from '../stores/authStore.js'
import OAuthButtons from '../components/auth/OAuthButtons.jsx'
import DevPasswordLogin from '../components/auth/DevPasswordLogin.jsx'
import BrandLogo from '../components/common/BrandLogo.jsx'

export default function Login() {
  const location = useLocation()
  const { isAuthenticated } = useAuthStore()
  const urlError = new URLSearchParams(location.search).get('error')

  if (isAuthenticated) {
    return <Navigate to={location.state?.from?.pathname || '/dashboard'} replace />
  }

  return (
    <div className="login-container">
      <div className="login-left">
        <div className="login-content">
          <div className="login-header">
            <h1>Bienvenue</h1>
            <p className="login-subtitle">Connectez-vous pour accéder à votre plateforme.</p>
          </div>

          <OAuthButtons />
          {import.meta.env.DEV && <DevPasswordLogin />}

          {urlError && (
            <p style={{ color: '#ef4444', fontSize: '0.9rem', marginTop: 16, textAlign: 'center' }}>
              {decodeURIComponent(urlError)}
            </p>
          )}
        </div>
      </div>

      <div className="login-right">
        <video className="background-video" autoPlay muted loop playsInline>
          <source src="/videos/vague_noir.mp4" type="video/mp4" />
        </video>
        <div className="video-overlay"></div>
        <div className="right-content">
          <div className="brand-logo">
            <BrandLogo />
          </div>
          <h2 className="right-title">Automatisez votre prospection</h2>
          <p className="right-description">
            Surfez sur la vague des entreprises qui génèrent plus de leads grâce à l'IA
          </p>
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">200M+</div>
              <div className="stat-label">Profils</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">98%</div>
              <div className="stat-label">Satisfaction</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">24/7</div>
              <div className="stat-label">Automatisation</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
